import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { styles } from "@insite/content-library/Widgets/ContactUs/AvailableTopics";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    containerSticky: InjectableCss;
    logoWrapper: InjectableCss;
    searchWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    stickProductsWrapper?: InjectableCss;
    stickProductsWrapperVisible?: InjectableCss;
    phoneNumber?: InjectableCss;
    phoneNumberWrapper?: InjectableCss;
    scrollFixed?: InjectableCss;
    phoneNumberWrapperSticky?: InjectableCss;
    logoWrapperSticky?: InjectableCss;
    mobileCartWrapper?: InjectableCss;
    positonfix?: InjectableCss;
    mobileCartWrapperSticky?: InjectableCss;
    cartWrapper?: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            max-width: 1140px;
            margin: 0 auto;
            width: 100%;
            height: 80px;
            transition: height 1s;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column;
                            height: 71px;
                        `,
                        css`
                            flex-direction: column;
                            height: 71px;
                        `,
                        css`
                            flex-direction: column;
                            height: 71px;
                        `,
                        css`
                            width: 90%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    containerSticky: {
        css: css`
            display: flex;
            justify-content: space-between;
            max-width: 1440px;
            margin: 0 auto;
        `,
    },
    logoWrapper: {
        css: css`
            width: 13%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            width: 16.66%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
            text-align: left;
            padding: 10px 0 3px;
            display: flex;
            align-items: center;
            a {
                width: 100%;
                padding: 0px !important;
                span {
                    width: 100%;
                    img {
                        height:auto;
                    }
                }
            }
            div[class^="headerlogo"] {
                span[class^="LazyImageStyle"] {
                    display: block;
                    margin-left: 10px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    display: flex;
                                    margin-left: 0px;
                                    align-items: center;
                                    justify-content: center;
                                `,
                                css`
                                    display: flex;
                                    margin-left: 0px;
                                    align-items: center;
                                    justify-content: center;
                                `,
                                css`
                                    display: flex;
                                    margin-left: 0px;
                                    align-items: center;
                                    justify-content: center;
                                `,
                                css`
                                    display: flex;
                                    margin-left: 0px;
                                    align-items: center;
                                    justify-content: center;
                                `,
                                null,
                            ],
                            "max",
                        );
                    }}
                }
            }

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            margin: 0;
                            > div[class^="Wrapper"] > div[class^="ContentWrapper"] {
                                > p[class^="TypographyStyle"] > span[class^="LazyImageStyle"] {
                                    display: flex !important;
                                    align-items: center !important;
                                }
                            }
                        `,
                        css`
                            width: 100%;
                            margin: 0;
                            > div[class^="Wrapper"] > div[class^="ContentWrapper"] {
                                > p[class^="TypographyStyle"] > span[class^="LazyImageStyle"] {
                                    display: flex !important;
                                    align-items: center !important;
                                }
                            }
                        `,
                        css`
                            width: 100%;
                            margin: 0;
                            flex-grow: 1;
                            > div {
                                > div {
                                    margin: auto;
                                    max-width: 140px;
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    searchWrapper: {
        css: css`
            width: 26%;
            margin-top: 20px;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
        css: css`
            height: 100%;
            div[class^="Wrapper"] {
                height: 100%;
                display: flex;
            }
        `,
    },
    stickProductsWrapper: {
        css: css`
            display: none;
        `,
    },
    stickProductsWrapperVisible: {
        css: css`
            margin-left: 2%;
            span[class^="StyledButton"] {
                height: 64px;
                padding-left: 0;
                padding-right: 15px;
                p {
                    color: ${getColor("text.accent")};
                    display: flex;
                    align-items: center;
                    border: 1px solid #ccc;
                    border-radius: 20px;
                    height: 40px;
                    padding: 2px 10px 0 15px;
                    font-size: 16px;
                    font-family: "HelveticaCondensed";
                    svg {
                        color: ${getColor("text.accent")};
                    }
                }
                & + div {
                    top: 65px;
                }
                &:hover {
                    p {
                        color: ${getColor("text.accent")} !important;
                        text-decoration: underline;
                    }
                }
            }
            [data-test-selector="expandMobileMenu"] {
                top: 5px;
                left: 5px;
            }
        `,
    },
    phoneNumber: {
        css: css`
            width: 100%;
            height: 100%;
            > div[class^="Wrapper"] {
                height: 100%;
                display: flex;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                            display: none;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    phoneNumberWrapper: {
        css: css`
            width: 58.33%;
            div[class^="ZoneWrapper"] {
                .megaMenuDrawerWrapper {
                    top: 25px !important;
                }
            }
            p.phoneNumber {
                border: 1px solid #cccccc;
                border-radius: 20px;
                height: 40px;
                display: flex;
                align-items: center;
                width: 100%;
                justify-content: center;
                a {
                    font-size: 13px;
                    height: auto;
                    span[class^="TypographyStyle"] {
                        display: flex;
                        align-items: flex-start;
                        color: ${getColor("text.accent")};
                        span {
                            height: 18px;
                            span[class^="LazyImageStyle"] {
                                img {
                                    width: 18px;
                                    height: 18px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }
            }
            @media all and (max-width: 1199px) and (min-width: 992px) {
                margin-left: 8px;
            }
        `,
    },
    scrollFixed: {
        css: css`
            display: block;
            z-index: 100;
            position: fixed;
            top: 0;
            left: 0;
            background: #fff;
            width: 100%;
            height: auto;
            border-bottom: 5px solid ${getColor("primary")};
            * {
                transition: all 0.4s ease;
            }
        `,
    },
    logoWrapperSticky: {
        css: css`
            text-align: left;
            padding: 2px 0 0 0;
            margin: 0 0 0 15px;
            width: 25%;
            a {
                width: 100%;
                span {
                    width: 100%;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            margin: 0;
                        `,
                        css`
                            width: 100%;
                            margin: 0;
                        `,
                        css`
                            width: 100%;
                            margin: 0;
                            flex-grow: 1;
                            display: none;
                        `,
                        css`
                            padding-top: 10px;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: 85px;
                width: auto;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            height: 42px;
                            width: auto;
                            margin: 0;
                        `,
                        css`
                            height: 42px;
                            width: auto;
                            margin: 0;
                        `,
                        css`
                            height: 42px;
                            width: auto;
                            margin: 0;
                        `,
                        null,
                        null,
                    ]);
                }}
            }
        `,
    },

    phoneNumberWrapperSticky: {
        css: css`
            display: flex;
            align-items: center;
            margin-left: 3%;
            p.phoneNumber {
                border: 1px solid #ccc;
                border-radius: 20px;
                height: 40px;
                display: flex;
                align-items: center;
                width: 100%;
                justify-content: center;
                a {
                    font-size: 13px;
                    height: auto;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                null,
                                css`
                                    font-size: 11px;
                                `,
                                null,
                            ],
                            "max",
                        );
                    }}
                    span[class^="TypographyStyle"] {
                        display: flex;
                        align-items: flex-start;
                        color: ${getColor("text.accent")};
                        span {
                            height: 18px;
                            span[class^="LazyImageStyle"] {
                                img {
                                    width: 18px;
                                    height: 18px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    mobileCartWrapper: {
        css: css`
            position: absolute;
            right: 15px;
            top: 10px;
            display: none;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: flex;
                            margin-top: 6px;
                        `,
                        css`
                            display: flex;
                            margin-top: 6px;
                        `,
                        css`
                            display: flex;
                            margin-top: 6px;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                    ],
                    "min",
                );
            }}

            span[class^="IconWrapper"] {
                background: ${getColor("text.secondary")};
                padding: 10px;
                border-radius: 20px;
                width: 40px;
                height: 40px;
                margin: 0;
                svg {
                    color: #fff;
                }
            }
            
            a[data-test-selector^="cartLink"]{
                height:auto;
                padding:0;
                margin:0;
                span[class^="IconWrapper"] {
                    padding:5px;
                    width:35px;
                    svg{
                        color: #33333a;
                    }
                }
                span{
                    color: #33333a;
                }
            }
        `,
    },
    positonfix: {
        css: css`
            position: fixed;
            top: 0;
            left: 0;
            padding: 0 !important;
            max-width: none !important;
            width: 100%;
            height: 50px;
            z-index: 99;
            background: #fff;
            .MenuBar {
                height: 50px !important;
            }
            #search_zone {
                margin-top: 0px;
                display: flex;
                align-items: center;
                justify-content: right;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    mobileCartWrapperSticky: {
        css: css`
            display: none;
            position: absolute;
            right: 15px;
            top: 5px;
            background-color: red;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: flex;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            span[class^="IconWrapper"] {
                background: ${getColor("text.accent")};
                padding: 10px;
                border-radius: 20px;
                width: 40px;
                height: 40px;
                margin: 0;
                svg {
                    color: #fff;
                }
            }
        `,
    },
};

const mapStateToProps = (state: ApplicationState) => ({
    currentLanguage: state.context.session.language,
});

type Props = PageProps & ReturnType<typeof mapStateToProps>;

const LogoLinksSearch: React.FC<Props> = ({ id, currentLanguage }) => {
    const [offset, setOffset] = useState(0);
    useEffect(() => {
        window.onscroll = () => {
            const check = window.parent.document.getElementById("siteIFrame");
            if (!check) {
                setOffset(window.pageYOffset);
            } else {
                setOffset(2000);
            }
        };
    }, []);

    return (
        <>
            <StyledWrapper id="MenuBAr">
                <StyledWrapper {...logoLinksSearchStyles.container} className="MenuBar">
                    <StyledWrapper id="logoWrapper" {...logoLinksSearchStyles.logoWrapper}>
                        <Zone contentId={id} zoneName="Logo" />
                    </StyledWrapper>
                    <StyledWrapper id="search_icon_mobile" {...logoLinksSearchStyles.mobileCartWrapper}>
                        <Zone contentId={id} zoneName="MobileCart" />
                        {currentLanguage?.languageCode.toLowerCase() === "en" &&
                        (<Zone contentId={id} zoneName="Cart"/>)}
                    </StyledWrapper>
                    <StyledWrapper id="phoneNumber" {...logoLinksSearchStyles.phoneNumberWrapper}>
                        <Hidden {...logoLinksSearchStyles.phoneNumber}>
                            <Zone contentId={id} zoneName="phoneNumber" />
                        </Hidden>
                    </StyledWrapper>
                    <StyledWrapper id="search_zone" {...logoLinksSearchStyles.searchWrapper}>
                        <Hidden>
                            <Zone contentId={id} zoneName="Search" />
                        </Hidden>
                    </StyledWrapper>
                    <Hidden above="md">
                        <StyledWrapper>
                            <Zone contentId={id} zoneName="MobileNAv" />
                        </StyledWrapper>
                    </Hidden>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const logoLinksSearch: WidgetModule = {
    component: connect(mapStateToProps)(LogoLinksSearch),
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
